import { HostListener, Component, ViewChild } from '@angular/core';

import {
    NavController,
    NavParams,
    PopoverController,
    ViewController
} from 'ionic-angular';

import { Horse } from '../../../../model/horse';
import { RodeoEvent } from '../../../../model/rodeoEvent';

import { AlertMessager } from "../../../../lib/alertMessager";
import { UserService } from "../../../../services/user.service";
import { AddHorsePage } from '../../../horse/add-horse';
import { AccountHelper } from '../../../../lib/accountHelper';
import { RodeoEventRun } from '../../../../model/rodeoEventRun';
import { RodeoEventSchedule } from '../../../../model/rodeoEventSchedule';
import { HorseService } from '../../../../services/horse.service';
import { RunService } from '../../../../services/run.service';
import { LoadingController } from 'ionic-angular';
import { Organization } from '../../../../model/organization';
import { SearchComponent } from '../../../../pages/search/search.component';
import { NewMemberPage } from '../memberships/new-member';

@Component({
    selector: 'page-new-run',
    templateUrl: 'new-run.html'
})
export class NewRunPage {
    @ViewChild('runNumber') runNumber;
    @ViewChild('userOneSearch') userOneSearch;
    @ViewChild('userTwoSearch') userTwoSearch;
    @ViewChild('horseSearch') horseSearch;
    @ViewChild('timeValue') timeValue;
    @ViewChild('livestockSearch') livestockSearch;

    accountHelper = AccountHelper.instance();
    
    rodeoEvent: RodeoEvent;
    schedule: RodeoEventSchedule;
    organizations: Organization[] = [];

    run: RodeoEventRun;

    showTeammate: boolean = false;
    showHorse: boolean = false;

    contestantOneName: string;
    teammateName: string;
    horseOneName: string;
    horseTwoName: string;
    horses: Horse[];

    swapTeammate: boolean;
    editing: boolean;
    popoverActive: boolean = false;

    keepAddingRuns: boolean = false;

    constructor(private nav: NavController, navParams: NavParams, private horseService: HorseService, private popoverController: PopoverController, private loadingControl: LoadingController,
        private runService: RunService, private alert: AlertMessager, private userService: UserService, private viewController: ViewController) {
        this.rodeoEvent = navParams.get('rodeoEvent');
        this.schedule = navParams.get('schedule');
        this.organizations = navParams.get('organizations');

        this.setupNewRun(navParams.get('run'), navParams.get('contestantOne'), navParams.get('contestantTwo'), navParams.get('horseOne'), navParams.get('horseTwo'), navParams.get('runNumber'), navParams.get('round'));
    }

    private focusElement(element) {
        const element2 = element._elementRef.nativeElement.querySelector('input');
        // we need to delay our call in order to work with ionic ...
        setTimeout(() => {
            //this.renderer.invokeElementMethod(element, 'focus', []);
            (element2 as any)['focus'].apply(element2, []);
        }, 0);
    }

    private isRoughStock(rodeoEvent) {
        if (rodeoEvent.eventType === 'BullRiding' || rodeoEvent.eventType === 'SaddleBroncRiding' || rodeoEvent.eventType === 'RanchBroncRiding' || rodeoEvent.eventType === 'BarebackRiding')
            return true;
        else
            return false;
    }

    private setupNewRun(run, contestantOne, contestantTwo, horseOne, horseTwo, runNumber, round) {
        if (!run) {
            this.run = new RodeoEventRun();
            this.run.number = runNumber;
            this.run.round = round;
            this.run.scheduleName = this.schedule.name;
            this.run.rodeoEventScheduleId = this.schedule.id;
            this.run.startingTime = 0;
            this.run.penaltyTime = 0;
            this.run.time = 0;
            this.run.totalTime = 0;
            this.run.startingScore = 0;
            this.run.score = 0;
            this.run.totalScore = 0;
            this.run.edited = true;
        } else {
            this.run = run;
            this.editing = true;
        }

        this.contestantOneName = null;
        this.teammateName = null;
        this.horseOneName = null;
        this.horseTwoName = null;

        if (contestantOne) {
            this.contestantOneName = contestantOne.firstName + ' ' + contestantOne.lastName;
            this.run.contestantOneId = contestantOne.id;
            this.run.contestantOne = contestantOne;
        }

        if (contestantTwo) {
            this.teammateName = contestantTwo.firstName + ' ' + contestantTwo.lastName;
            this.run.contestantTwoId = contestantTwo.id;
            this.run.contestantTwo = contestantTwo;
        }

        if (horseOne) {
            this.horseOneName = horseOne.name;
            this.run.horseOneId = horseOne.id;
            this.run.horseOne = horseOne;
        }

        if (horseTwo) {
            this.horseTwoName = horseTwo.name;
            this.run.horseTwoId = horseTwo.id;
            this.run.horseTwo = horseTwo;
        }

        this.showTeammate = this.rodeoEvent.configuration.entries.showContestantTwo;
        this.showHorse = this.rodeoEvent.configuration.entries.showHorseOne;

        setTimeout(() => {
            this.focusElement(this.userOneSearch);
        });
    }

    openUserSearch(searchEvent, teammateSearch) {
        if (this.popoverActive)
            return;

        this.popoverActive = true;

        let popover = this.popoverController.create(SearchComponent, {
            config: {
                searchTitle: (teammateSearch ? this.rodeoEvent.configuration.runs.slotTwoLabel : this.getFirstLabel(this.rodeoEvent)) + " Search",
                userSearch: true,
                addNew: true
            },
            organizations: this.organizations
        }, { cssClass: 'app-search' });

        popover.present();

        popover.onDidDismiss((data) => {
            this.popoverActive = false;

            if (data != null) {
                if (data.id > 0) {
                    if (teammateSearch) {
                        this.teammateName = data.firstName + ' ' + data.lastName;
                        this.run.contestantTwoId = data.id;
                        this.run.contestantTwo = data;
                    } else {
                        this.contestantOneName = data.firstName + ' ' + data.lastName;
                        this.run.contestantOneId = data.id;
                        this.run.contestantOne = data;

                        if (this.showTeammate)
                            this.focusElement(this.userTwoSearch);
                        else if (!this.isRoughStock(this.rodeoEvent))
                            this.focusElement(this.horseSearch);
                    }
                } else {

                    let accountCallBack = ((newAccount) => {
                        if (newAccount != null) {
                            if (teammateSearch) {
                                this.teammateName = newAccount.firstName + ' ' + newAccount.lastName;
                                this.run.contestantTwoId = newAccount.id;
                                this.run.contestantTwo = newAccount;
                            } else {
                                this.contestantOneName = newAccount.firstName + ' ' + newAccount.lastName;
                                this.run.contestantOneId = newAccount.id;
                                this.run.contestantOne = newAccount;

                                if (this.showTeammate)
                                    this.focusElement(this.userTwoSearch);
                                else if (!this.isRoughStock(this.rodeoEvent))
                                    this.focusElement(this.horseSearch);
                            }
                        }
                    });

                    let entryModal = this.popoverController.create(NewMemberPage, { account: null, organizations: this.organizations, firstName: data.firstName, lastName: data.lastName, callback: accountCallBack }, { cssClass: 'page-new-member', enableBackdropDismiss: true });

                    entryModal.present();
                    entryModal.onDidDismiss((newAccount) => {
                        this.popoverActive = false;
                    });

                }
            }
        })
    }

    openHorseSearch(event, horses) {
        if (this.popoverActive)
            return;

        this.popoverActive = true;


        let popover = this.popoverController.create(SearchComponent, {
            config: {
                searchTitle: "Horse Search",
                horseSearch: true,
                userSearch: true,
                addNew: true
            },
            userIds: [this.run.contestantOneId],
            userHorses: true,
            organizations: this.organizations
        }, { cssClass: 'app-search' });

        popover.present({ ev: event });

        popover.onDidDismiss((data) => {
            this.popoverActive = false;

            if (data != null) {
                if (data.id) {
                    this.horseOneName = (data as Horse).name;
                    this.run.horseOne = (data as Horse);
                    this.run.horseOneId = (data as Horse).id;

                    if (this.rodeoEvent.configuration.runs.scoreValue)
                        this.run.score = '';
                    else
                        this.run.time = '';

                    this.focusElement(this.timeValue);
                } else {
                    if (this.popoverActive)
                        return;

                    this.popoverActive = true;

                    this.horseService.addHorse(this.run.contestantOneId, data)
                        .then((data) => {
                            this.popoverActive = false;

                            if (data != null && data != undefined) {
                                this.horseOneName = (data as Horse).name;
                                this.run.horseOne = (data as Horse);
                                this.run.horseOneId = (data as Horse).id;
                            }
                        })
                }
            }
        });
    }

    openSecondSearch(event) {
        if (this.run.contestantOne == null) {
            this.alert.showError("Error", "You must select a contestant first.");
        } else {
            if (this.rodeoEvent.eventType == "TeamRoping") {
                this.openUserSearch(event, true);
            } else {
                let loading = this.loadingControl.create({
                    content: "Retrieving user's horses...",
                });

                loading.present();
                this.horseService.getHorses([this.run.contestantOne.id])
                    .then((data) => {
                        loading.dismiss();
                        this.openHorseSearch(event, (data as Horse[]));
                    }, error => {
                        loading.dismiss();
                        this.alert.showError("Horse Retrieval", "Unable to retrieve user horses.");
                    });
            }
        }
    }

    getFirstLabel(rodeoEvent: RodeoEvent) {
        switch (rodeoEvent.eventType) {
            case 'TeamRoping':
                return 'Header';
            default:
                return 'Rider';
        }
    }

    addHorse() {
        if (this.popoverActive)
            return;

        this.popoverActive = true;

        let popover = this.popoverController.create(AddHorsePage, {}, { cssClass: 'page-add-horse' });

        popover.present();

        popover.onDidDismiss((data) => {
            this.popoverActive = false;

            if (data != null) {
                this.horseOneName = (data as Horse).name;
                this.run.horseOneId = (data as Horse).id;
                this.horses.push(data);
            }
        })
    }

    noTime() {
        this.updateSelectedRun(this.run.noTime, false, 0);
    }

    oneLeg() {
        this.run.oneLeg = !this.run.oneLeg;

        var penaltyTimeAdjustment = this.run.oneLeg ? 5 : -5;
        this.run.penaltyTime = +this.run.penaltyTime + penaltyTimeAdjustment;

        this.updateSelectedRun(false, true, penaltyTimeAdjustment);
    }

    barrier() {
        this.run.barrierOneBreak = !this.run.barrierOneBreak;

        var penaltyTimeAdjustment = this.run.barrierOneBreak ? +this.rodeoEvent.barrierPenalty : -this.rodeoEvent.barrierPenalty;
        this.run.penaltyTime = +this.run.penaltyTime + penaltyTimeAdjustment;

        this.updateSelectedRun(false, true, penaltyTimeAdjustment);
    }

    barrierAndLeg() {
        var wasLeg = this.run.oneLeg;
        var wasbarrierOneBreak = this.run.barrierOneBreak;
        var wasBoth = wasLeg && wasbarrierOneBreak;

        if (wasBoth) {
            this.run.oneLeg = false;
            this.run.barrierOneBreak = false;
        } else {
            this.run.oneLeg = true;
            this.run.barrierOneBreak = true;
        }

        var penaltyTimeAdjustment = wasLeg ? (this.run.oneLeg ? 0 : -5) : (this.run.oneLeg ? 5 : 0);
        penaltyTimeAdjustment += wasbarrierOneBreak ? (this.run.barrierOneBreak ? 0 : -this.rodeoEvent.barrierPenalty) : (this.run.barrierOneBreak ? +this.rodeoEvent.barrierPenalty : 0);

        this.run.penaltyTime = +this.run.penaltyTime + penaltyTimeAdjustment;

        this.updateSelectedRun(false, true, penaltyTimeAdjustment);
    }

    crossfire() {
        this.run.crossfire = !this.run.crossfire;

        if (this.rodeoEvent.crossfireTimePenalty > 0) {
            var penaltyTimeAdjustment = this.run.crossfire
                ? +this.rodeoEvent.crossfireTimePenalty
                : -this.rodeoEvent.crossfireTimePenalty;
            this.run.penaltyTime =
                +this.run.penaltyTime + penaltyTimeAdjustment;

            this.updateSelectedRun(false, true, penaltyTimeAdjustment);
        } else if (this.rodeoEvent.crossfireTimePenalty === 0) {
            this.run.noTime = !this.run.noTime;
            this.updateSelectedRun(!this.run.crossfire, false, 0);
        }
    }

    penalty(time, count) {
        let newPenaltyTime = time * 1 * count * 1;
        let penaltyTimeAdjustment = 0;

        penaltyTimeAdjustment = newPenaltyTime == +this.run.penaltyTime ? -newPenaltyTime : +newPenaltyTime - +this.run.penaltyTime;

        this.run.penaltyTime = +this.run.penaltyTime + penaltyTimeAdjustment;

        this.updateSelectedRun(false, true, penaltyTimeAdjustment);
    }

    headerMiss() {
        this.run.headerMiss = !this.run.headerMiss;
        this.updateSelectedRun(!this.run.headerMiss, false, 0);
    }

    heelerMiss() {
        this.run.heelerMiss = !this.run.heelerMiss;
        this.updateSelectedRun(!this.run.heelerMiss, false, 0);
    }

    toggleTurnout() {
        if (this.run.turnedOut) {
            this.run.turnedOut = false;
        } else {
            this.run.turnedOut = true;
            this.run.done = true;
        }

        this.updateSelectedRun(false, false, 0);
    }

    updateSelectedRun(clean, penalty, penaltyTimeAdjustment) {
        this.run.saving = true;
        this.run.done = true;

        if (clean) {
            this.run.noTime = false;
            this.run.penaltyTime = 0;

            this.run.time = (this.run.time * 1).toFixed(this.rodeoEvent.configuration.runs.decimalPlaces);

            this.run.totalTime = +(this.run.startingTime * 1 + this.run.time * 1).toFixed(this.rodeoEvent.configuration.runs.decimalPlaces);
            this.run.totalScore = +(this.run.startingScore * 1 + this.run.score * 1).toFixed(this.rodeoEvent.configuration.runs.decimalPlaces);
        } else if (penalty) {
            if (!this.rodeoEvent.configuration.runs.scoreValue)
                this.run.time = +this.run.time + penaltyTimeAdjustment;

            this.run.noTime = false;

            if (this.rodeoEvent.configuration.runs.scoreValue) {
                this.run.score = (this.run.score * 1 - penaltyTimeAdjustment).toFixed(this.rodeoEvent.configuration.runs.decimalPlaces);
            }

            this.run.time = (this.run.time * 1).toFixed(this.rodeoEvent.configuration.runs.decimalPlaces);

            this.run.totalTime = +(this.run.startingTime * 1 + this.run.time * 1).toFixed(this.rodeoEvent.configuration.runs.decimalPlaces);
            this.run.totalScore = +(this.run.startingScore * 1 + this.run.score * 1).toFixed(this.rodeoEvent.configuration.runs.decimalPlaces);
        } else {
            this.run.noTime = true;

            if (this.rodeoEvent.configuration.runs.scoreValue) {
                this.run.score = (this.run.score * 1).toFixed(this.rodeoEvent.configuration.runs.decimalPlaces);
                this.run.totalScore = this.run.startingScore;
            }

            this.run.time = (this.run.time * 1).toFixed(this.rodeoEvent.configuration.runs.decimalPlaces);
            this.run.totalTime = this.run.startingTime;
        }

        this.create();
    }

    create() {
        if (this.rodeoEvent.eventType == 'TeamRoping' && (this.run.contestantTwoId == null || this.run.contestantTwoId == undefined)) {
            this.alert.showError("Entry Invalid", "You must select a teammate.");
            return;
        }

        let loading = this.loadingControl.create({
            content: (this.editing ? 'Updating ' : 'Creating ') + 'run...',
        });

        if (!this.run.time)
            this.run.time = 0;

        if (!this.run.score)
            this.run.score = 0;

        loading.present();
        if (this.editing) {
            this.runService.updateRuns([this.run])
            .then(data => {
                loading.dismiss();

                if ((data as any).message != null && (data as any).message != undefined) {
                    this.alert.showError("Run Update Failed", (data as any).message);
                } else {
                    loading.dismiss();
                    if (this.keepAddingRuns) {
                        this.setupNewRun(null, null, null, null, null, this.run.number + 1, this.run.round)
                    } else {
                        this.viewController.dismiss({ run: data });
                    }
                }
            }, error => {
                loading.dismiss();
                this.alert.showError("Run Update Error", error);
            });
        } else {
            this.runService.createRun(this.run)
            .then(data => {
                loading.dismiss();

                if ((data as any).message != null && (data as any).message != undefined) {
                    this.alert.showError("Create Run Failed", (data as any).message);
                } else {
                    this.runService.addTempAdded((data as RodeoEventRun).id);

                    if (this.run.time != 0 || this.run.score != 0 || this.run.noTime || this.run.turnedOut) {
                        this.run.id = (data as RodeoEventRun).id;
                        this.run.done = true;

                        let loading = this.loadingControl.create({
                            content: 'Updating run...',
                        });
                
                        loading.present();
                        this.runService.updateRuns([this.run])
                            .then(data => {
                                loading.dismiss();
                                if (this.keepAddingRuns) {
                                    this.setupNewRun(null, null, null, null, null, this.run.number + 1, this.run.round)
                                } else {
                                    this.viewController.dismiss({ run: data });
                                }
                            }, error => {
                                loading.dismiss();
                                this.alert.showError("Run Update Error", error);
                            });
                    } else {
                        if (this.keepAddingRuns) {
                            this.setupNewRun(null, null, null, null, null, this.run.number + 1, this.run.round)
                        } else {
                            this.viewController.dismiss({ run: data });
                        }
                    }
                }
            }, error => {
                loading.dismiss();
                this.alert.showError("Run Create Error", error);
            });
        }
    }

    cancel() {
        this.nav.pop();
    }

    back() {
        this.nav.pop();
    }

    _bdClick() {
        return this.nav.pop();
    }

    @HostListener('body:keyup', ['$event'])
    _keyUp(ev: KeyboardEvent) {
        if (!this.viewController.isLast() || this.popoverActive || AlertMessager.showingAlert)
            return;

        if (ev.keyCode === 13) {
            this.create();
        } else if (ev.keyCode === 27) {
            this._bdClick().catch((err) => {
                console.warn(err);
            });
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/rodeo/draw/new-run.ts